// suppress linter errors about d3 being undefined
// we require("../js/libs/d3.min.js") in app/static/frontend/index.jsx
/* global d3 */

import { useMemo } from "react"

export const useBarStackedSeries = ({
    data,
    groupKey,
    // 100% stacked
    percentage,
    keys,
    shouldOrderByDate,
    timestamp,
}) =>
    useMemo(() => {
        if (!timestamp) {
            return []
        }

        return d3
            // TODO: uncomment below and delete .layout.stack()(keys...) after d3 v5 upgrade
            // https://github.com/d3/d3-shape#stack
            // .stack()
            // https://github.com/d3/d3-shape#stack_keys
            // .keys(keys)(data)

            // Constructs a new stack layout with the default offset (zero) and order (null).
            // https://d3-wiki.readthedocs.io/zh_CN/master/Stack-Layout/#stack
            .layout
            .stack()
            // TODO: uncomment below and delete .offset(...) after d3 v5 upgrade
            // https://github.com/d3/d3-shape#stackOffsetExpand
            // .offset(d3.stackOffsetExpand)

            // If offset is specified, sets the stack offset algorithm to the specified value.
            // expand - normalize layers to fill the range [0,1].
            // zero (default) - use a zero baseline, i.e., the y-axis.
            // https://d3-wiki.readthedocs.io/zh_CN/master/Stack-Layout/#offset
            .offset(
                percentage
                    // 100% stacked
                    ? "expand"
                    : "zero"
            )(
            // TODO: uncomment below and delete (keys.map(...)) after d3 v5 upgrade
            // (data).map(d => (d.forEach(v => v.key = d.key), d))
                keys.map((key, i) => (
                    // if date-type FrequencyTupleField, sorts groups by date
                    shouldOrderByDate
                        ? data
                            .sort((a, b) => (
                                Date.parse(a.name) - Date.parse(b.name)
                            ))
                            .map(d => (
                                {
                                    key,
                                    // index of dataSource
                                    keyIndex: i,
                                    x: d[groupKey],
                                    xOriginal: d[`${groupKey}Original`],
                                    // why do we need d[key] || 0?
                                    // see the barStackedRenderers.test.js for full explanation
                                    y: d[key] || 0,
                                }
                            ))
                        : data.map(d => (
                            {
                                key,
                                // index of dataSource
                                keyIndex: i,
                                x: d[groupKey],
                                xOriginal: d[`${groupKey}Original`],
                                // why do we need d[key] || 0?
                                // see the barStackedRenderers.test.js for full explanation
                                y: d[key] || 0,
                            }
                        ))
                ))
            )
    }, [timestamp, percentage])
